import React from 'react';

export default function Steps({ title, description, children }) {
    return (
        <div className="py-[48px] steps-bg ">
            <div className="container flex flex-col lg:flex-row lg:items-center">
                <div className='lg:max-w-[620px] lg:mr-[59px] mt-[30px] md:mt-[60px] lg:mt-0'>
                    <p className='text-purple text-16 font-dmsans_b mb-[12px]'>How it works</p>
                    <div className='max-w-[479px]'>{title}</div>
                    <p className="text-16 sm:text-20 text-[#667085] font-dmsans_r leading-[30px] mb-[48px]">{description}</p>
                </div>
                <div className='flex justify-center w-full md:min-w-[500px]'>{children}</div>
            </div>
        </div>
    );
};
